import { render, staticRenderFns } from "./SignInPCNew.vue?vue&type=template&id=4b204c98&scoped=true&"
import script from "./SignInPCNew.vue?vue&type=script&lang=js&"
export * from "./SignInPCNew.vue?vue&type=script&lang=js&"
import style0 from "./SignInPCNew.vue?vue&type=style&index=0&id=4b204c98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b204c98",
  null
  
)

export default component.exports